import React, { useContext } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
import { Carousel } from "../carousel/carousel";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, HashNavigation } from "swiper/modules";
import "./shopByconcern.css";
import { AuthContext } from "../../context/AuthContext";
import { ProductContext } from "../../context/ProductContext";
import { Link } from "react-router-dom";
// import { Carousel } from "bootstrap/dist/js/bootstrap.bundle.min";
export const ShopByconcern = () => {
  const { getProductsByType } = useContext(ProductContext);
  const featureProducts = getProductsByType("Shop by Concern");
  console.log(featureProducts);
  if (!featureProducts.length) return <div>Loading...</div>;

  // if (dataLoading) return <div>Loading...</div>;
  // if (dataError) return <div>Error: {dataError.message}</div>;

  return (
    <div className="shop-by-concern">
     <div className="shop-by-concern-header">
  <div className="divider-leftC"></div>
  <div><strong>Premium Seed Mix Medley</strong></div>

  <div className="divider-rightC"></div>
</div>

      {/* <Swiper
        slidesPerView={4}
        spaceBetween={50}
        pagination={{
          clickable: true,
        }}
        hashNavigation={{
          watchState: true,
        }}
        navigation={true}
        loop={true}
        modules={[Pagination, Navigation, HashNavigation]}
        className="concernSwiper"
      >
        {featureProducts.map((concern, index) => (
          <SwiperSlide key={concern.id}>
            <div className="carousel-concern-inner">
              <div key={index} className="concern-product-image">
                <Link to={`/productDetails/${concern.id}`}>
                  <img
                    src={concern.imageUrl}
                    alt={concern.title}
                    width={"40px"}
                    height={"40px"}
                  />
                </Link>
              </div>
              <div className="concern-product-name">{concern.name}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper> */}
      <div className="shop-concern-carousel">
        <Carousel featureProducts={featureProducts} />
      </div>
    </div>
  );
};
